import { lazy } from "react";

import { AppRoutings } from "utility/enums/app-routings";
import { MenuName } from "utility/enums/user-access-right";

interface IRoute {
	path: string;
	Component: React.LazyExoticComponent<React.FC<{}>> | React.ComponentType<{}>;
	pageName: string; // required to display error with page name - if user do not have permission (e.g. "You do not have permission to access departments page.")
	moduleName?: string; // required to display error with module name - if user do not have permission (e.g. "You do not have permission to add/update/delete requisition detail.")
}

export const vendorRoutes: IRoute[] = [
	{
		path: AppRoutings.SupplyChainManagementPortal,
		Component: lazy(() => import("components/SupplyChainManagementPortal")),
		pageName: MenuName.SupplyChainManagementPortal,
		moduleName: "Supply Chain Management Portal",
	},
	{
		path: AppRoutings.CompanyProfile,
		Component: lazy(() => import("components/CompanyProfile")),
		pageName: MenuName.CompanyProfile,
		moduleName: "Company Profile",
	},
	{
		path: AppRoutings.InvoiceUploadSummaryGrid,
		Component: lazy(
			() =>
				import(
					"components/SupplyChainManagementPortal/InvoiceUpload/InvoiceUploadSummaryGrid"
				)
		),
		pageName: MenuName.InvoiceUploadSummaryGrid,
		moduleName: "Invoice Upload Summary Grid",
	},
	{
		path: AppRoutings.SupplierDocumentUpload,
		Component: lazy(
			() =>
				import(
					"components/SupplyChainManagementPortal/SupplierDocumentUpload/SupplierDocumentUploadWrapper"
				)
		),
		pageName: MenuName.InvoiceUploadSummaryGrid,
		moduleName: "Supplier Document Upload",
	},
	{
		path: AppRoutings.SupplierBidSummary,
		Component: lazy(
			() =>
				import("components/SupplyChainManagementPortal/SupplierBidSummaryGrid")
		),
		pageName: MenuName.SupplierBidSummary,
		moduleName: "Supplier Bid Summary",
	},
	{
		path: AppRoutings.QuerySummary,
		Component: lazy(
			() => import("components/SupplyChainManagementPortal/QuerySummaryGrid")
		),
		pageName: MenuName.QuerySummary,
		moduleName: "Supplier Bid Summary",
	},
	{
		path: AppRoutings.SupplierBidDetail,
		Component: lazy(
			() => import("components/SupplyChainManagementPortal/ManageBid")
		),
		pageName: MenuName.SupplierBidSummary,
		moduleName: "Supplier Bid Detail",
	},
	{
		path: AppRoutings.VendorBidQuery,
		Component: lazy(
			() => import("components/SupplyChainManagementPortal/VendorBidQuery")
		),
		pageName: MenuName.QuerySummary,
	},
	{
		path: AppRoutings.SupplierBillingPeriodDetail,
		Component: lazy(
			() =>
				import(
					"components/SupplyChainManagementPortal/InvoiceUpload/SupplierPeriodBillingEntry"
				)
		),
		pageName: MenuName.InvoiceUploadSummaryGrid,
	},
];
